<td tid="person-name">
  <app-body-md semiBold>{{ personName }}</app-body-md>
</td>
<td *ngFor="let day of personCalendarMonthDays$ | async" [ngClass]="getDayCss(day)" (click)="clickDay(day)">
  <app-action-menu
    *ngIf="actionMenuItems && actionMenuItems.length > 0 && !day?.hasEvent"
    [actions]="actionMenuItems"
    tid="person-events-menu"
    [showButton]="false"
    [data]="day"
  ></app-action-menu>
  <app-calendar-day-icon *ngIf="day?.hasEvent" [day]="day" [isPersonRow]="true"></app-calendar-day-icon>
</td>
